import * as React from "react";
import ContentLoader from "react-content-loader";


export const WorkkardListingLoader = props =>{
    return(<>
  {props.count && props.count > 0 && (
                Array.from({ length: props.count }, (_, i) => ( <ContentLoader 
                    speed={2}
                    width={969}
                    height={40}
                    keySplines={i+1}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                <rect x="5" y="20" rx="5" ry="5" width="110" height="8"></rect>
                <rect x="160" y="20" rx="5" ry="5" width="110" height="8"></rect>
                <rect x="326" y="20" rx="5" ry="5" width="160" height="8"></rect>
                <rect x="626" y="20" rx="5" ry="5" width="110" height="8"></rect>
                <rect x="829" y="20" rx="5" ry="5" width="110" height="8"></rect>
                <circle cx="596" cy="25" r="12"></circle>
                </ContentLoader>
                ))
            )}</>)
}